import { adaptLoginQuestionTypeToQuestionType } from '../utilities';

import { generateLoginFieldBaseFieldId } from '@/forms/utils';
import { FormValidation, LoginFormField } from '@/forms/typings';
import { QuestionsResponseDTO } from '@/api/account-controller/DTOs';
import {
  DateFormFieldBuilder,
  InputFormFieldBuilder,
  LoginFormFieldBuilder,
} from '@/forms/builders';

export const adaptQuestionsResponseToLoginFormFields = (
  accountQuestionsResponse: QuestionsResponseDTO['questions'],
): LoginFormField[] =>
  accountQuestionsResponse.map(question => {
    const questionType = adaptLoginQuestionTypeToQuestionType(question.type);

    const baseFieldId = generateLoginFieldBaseFieldId(questionType);

    return new LoginFormFieldBuilder()
      .fieldId(`${baseFieldId}_group`)
      .questionType(questionType)
      .field(
        question.fieldType === 'date'
          ? new DateFormFieldBuilder()
              .fieldId(baseFieldId)
              .name(baseFieldId)
              .label(question.question)
              .readonly(false)
              .size(12)
              .validations([{ type: FormValidation.Required }])
              .hasAnyValue(true)
              .build()
          : new InputFormFieldBuilder()
              .fieldId(baseFieldId)
              .name(baseFieldId)
              .label(question.question)
              .readonly(false)
              .size(12)
              .validations([{ type: FormValidation.Required }])
              .hasAnyValue(true)
              .build(),
      )
      .build();
  });
